<div id="node-container" tabindex="0">
    <div class="title" data-testid="title">{{ data.label }}</div>
    <div class="node-content">
        <div class="inputs">
            <div class="input" *ngFor="let input of data.inputs | keyvalue: sortByIndex" [attr.data-testid]="'input-' + input.key">
                <div
                    class="input-socket"
                    refComponent
                    [data]="{ type: 'socket', side: 'input', key: input.key, nodeId: data.id, payload: input.value?.socket, seed: seed }"
                    [emit]="emit"
                    data-testid="input-socket"></div>
                <div class="input-title" data-testid="input-title" *ngIf="!input.value?.control || !input.value?.showControl">
                    {{ input.value?.label }}
                </div>
            </div>
        </div>
        <div class="data">
            @for (workflowData of workflowActionData | keyvalue; track $index) {
                <div class="property">
                    <span class="property-label">{{ workflowData.key }} :</span>
                    <span class="property-value">{{ workflowActionData[workflowData.key] }}</span>
                </div>
            }
        </div>
    </div>
</div>
